export default {
    name: 'AuditingData',

    props: {
        operation: {
            type: Object,
            required: true
        }
    },

    methods: {
        /**
         * Get update user fullname
         * @return {String} update user fullname
         */
        getUpdateUserFullName() {
            return this.operation.update_user ? `${this.operation.update_user.given_name} ${this.operation.update_user.family_name_1} ${this.operation.update_user.family_name_2 ? this.operation.update_user.family_name_2 : ''}` : '';
        },
        /**
         * Get creation user fullname
         * @return {String} creation user fullname
         */
        getCreationUserFullName() {
            return this.operation.update_user ? `${this.operation.creation_user.given_name} ${this.operation.creation_user.family_name_1} ${this.operation.creation_user.family_name_2 ? this.operation.creation_user.family_name_2 : ''}` : '';
        }
    }
};
